import {
  User,
  Settings,
  FileText,
  Home,
  DollarSign,
  Clock,
  Coffee,
  AlertTriangle,
  UsersRound,
  MessageSquare,
} from "lucide-react";

// Navigation menu items with translations
export const getNavItems = (t) => [
  {
    icon: User,
    text: t.profile,
    page: "professionalProfile",
  },
  {
    icon: Clock,
    text: t.attendance,
    page: "attendance",
  },
  {
    icon: DollarSign,
    text: t.salaryBenefits,
    page: "salary",
  },
  {
    icon: FileText,
    text: t.employeeSelfServices,
    page: "employee-services",
  },
  {
    icon: Home,
    text: t.calendar,
    page: "calendar",
  },
  {
    icon: MessageSquare,
    text: t.messages,
    page: "messages",
  },
  {
    icon: Coffee,
    text: t.leaveManagement,
    page: "leave-management",
  },
  {
    icon: AlertTriangle,
    text: t.escalation,
    page: "escalation",
  },
  {
    icon: UsersRound,
    text: t.groups,
    page: "groups",
  },
  {
    icon: Settings,
    text: t.settingsLocked,
    page: "settings",
  },
];
